import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IMMAccountModel } from '@apps-common/types/my-monitoring/account'

export const updateAccount = async (model: IMMAccountModel, image: any): Promise<IMMAccountModel> =>
  new Promise((resolve, reject) => {
    axios
      .post(`/my-monitoring/account/UpdateMyAccount`, model)
      .then((res) => {
        if (image) {
          const fileData = new FormData()

          fileData.append('file', image?.blob || image)
          axios
            .post(`/my-monitoring/account/UploadImg`, fileData)
            .then((imageRes) => resolve(imageRes?.data?.data))
            .catch((err) => reject(err))
        } else {
          resolve(res?.data?.data)
        }
      })
      .catch((err) => reject(err))
  })

type Props = {
  model: IMMAccountModel
  image?: any
}

export const useMyMonitoringUpdateAccount = (notify?: boolean, onSuccess?: (data: IMMAccountModel) => void) =>
  useMutation({
    mutationKey: ['updateMyMonitoringAccount'],
    mutationFn: ({ model, image }: Props) => updateAccount(model, image),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated account.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to update account.')
      }
    },
    throwOnError: false
  })
